module.exports = require('buffer')



//////////////////
// WEBPACK FOOTER
// ./~/string_decoder/~/safe-buffer/browser.js
// module id = 1601
// module chunks = 1